function Validation(/* values */) {
  const errors = {};

  return errors;
}

export default Validation;
